import { render } from "./PhilipsProject.vue?vue&type=template&id=204bf280"
const script = {}

import "./PhilipsProject.vue?vue&type=style&index=0&id=204bf280&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__